import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { UserStateService } from 'src/app/auth/services/user-state.service';

@Component({
  selector: 'install',
  templateUrl: './install.component.html',
  styleUrl: './install.component.scss',
  standalone: false,
})
export class InstallComponent {
  constructor(
    public location: Location,
    private readonly userStateService: UserStateService,
  ) {}

  get hasDaRole(): boolean {
    return this.userStateService.hasPermission('da');
  }
}
